import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { initGA } from "../lib/ga";

const SettingsContext = createContext({ settings: null });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings/public")
      .then((r) => {
        setSettings(r.data);
        if (r.data?.ga_measurement_id) initGA(r.data.ga_measurement_id);
      })
      .catch(() => setSettings({}));
  }, []);
  return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
